import React from 'react';
import Input from '../ui/Input';
import Button from '../ui/Button';
import { useIqamaStore } from '../../state/storeIqamaDelay';

const IqamaDelay = () => {
	const IQFajr = useIqamaStore( ( state ) => state.IQFajr );
	const IQDhuhr = useIqamaStore( ( state ) => state.IQDhuhr );
	const IQAsr = useIqamaStore( ( state ) => state.IQAsr );
	const IQMaghrib = useIqamaStore( ( state ) => state.IQMaghrib );
	const IQIsha = useIqamaStore( ( state ) => state.IQIsha );
const refUpload = React.useRef<HTMLDialogElement>( null );
	const handlePress = () => {
		refUpload.current?.showModal();
	}

	return (
		<div className="">
			<h2 className="text-lg text-green-600 py-2">
				Iqamah delay (in minutes)
			</h2>
			<div className="grid gap-1 grid-cols-2 grid-rows-3">
				<Input value={ IQFajr } label="IQFajr" />
				<Input value={ IQDhuhr } label="IQDhuhr" />
				<Input value={ IQAsr } label="IQAsr" />
				<Input value={ IQMaghrib } label="IQMaghrib" />
				<Input value={ IQIsha } label="IQIsha" />
				<Button refUpload={ refUpload } onPress={ handlePress } text="Upload" label="Upload CSV" />
			</div>
		</div>
	);
};

export default IqamaDelay;
